import apiClient from './client';
import { Robot, RobotCreateResponse } from '../types';

export type { Robot } from '../types';

export async function fetchRobots(): Promise<Robot[]> {
  const res = await apiClient.get<Robot[]>('/api/v1/robots');
  return res.data;
}

export async function fetchRobot(id: string): Promise<Robot> {
  const res = await apiClient.get<Robot>(`/api/v1/robots/${id}`);
  return res.data;
}

export async function uploadRobot(file: File): Promise<RobotCreateResponse> {
  const formData = new FormData();
  formData.append('file', file);
  const res = await apiClient.post<RobotCreateResponse>('/api/v1/robots', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data;
}

export async function updateRobot(
  id: string,
  data: Partial<Pick<Robot, 'name' | 'description'>>,
): Promise<Robot> {
  const res = await apiClient.patch<Robot>(`/api/v1/robots/${id}`, data);
  return res.data;
}

export async function deleteRobot(id: string): Promise<void> {
  await apiClient.delete(`/api/v1/robots/${id}`);
}

export async function importRobotFromGithub(
  codeUrl: string,
  codeRef?: string,
): Promise<RobotCreateResponse> {
  const res = await apiClient.post<RobotCreateResponse>('/api/v1/robots/import-github', {
    code_url: codeUrl,
    code_ref: codeRef,
  });
  return res.data;
}

export async function uploadThumbnail(id: string, blob: Blob): Promise<void> {
  const formData = new FormData();
  formData.append('file', blob, 'thumbnail.png');
  await apiClient.post(`/api/v1/robots/${id}/thumbnail`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}

export async function fetchRobotThumbnailUrl(id: string): Promise<string> {
  const res = await apiClient.get<{ url: string }>(`/api/v1/robots/${id}/thumbnail`);
  return res.data.url;
}

export interface RobotAssetUrl {
  key: string;
  url: string;
}

export interface RobotAssetsResponse {
  urdf: RobotAssetUrl | null;
  meshes: RobotAssetUrl[];
}

export async function fetchRobotAssets(id: string): Promise<RobotAssetsResponse> {
  const res = await apiClient.get<RobotAssetsResponse>(`/api/v1/robots/${id}/assets`);
  return res.data;
}
